<template>
  <div>
    <section class="permanently-close-acc">
      <div class="sidebar-container"></div>
      <div class="main-contents">
        <ul class="breadcrumbs-list">
          <a href="javascript:void(0)" @click="backButton"
            ><li>Accounts</li></a
          >
          <li>&nbsp;>&nbsp;Account Details</li>
        </ul>
         <h2><span style="color:#1A407D;font-size:27px"> MY</span><span style="color:#F19700; font-size:18px; top:12px"> WILL</span></h2>
        <v-card class="center-box">
        <v-img class="checked" height="66px" width="60" :src="require('@/assets/images/checked.png')"> </v-img>
          <h2 class="thank-box">
           Thank you!
          </h2>
          <div class="will-payment-p1">
          <span>
           Your payment has been successful.</span>
           <br>
           <span> Please check your mail for the invoice.</span>
          </div>
          <div class="will-payment-p2">
            <br>
            <span>Please note that the payment towards notarization or registration for your “WILL” 
              <br>will be additional and has to be borne by you and the charges may vary across states. 
              <br>The charges for notarization or registration will be as prevailing at the time of 
              <br>notarization or registration of WILL.
          </span>
          </div>
         
          <button class="will-creation-btn" @click="willcreation()" v-if="this.$route.params.type == 'amend'">PROCEED TO WILL AMENDATION</button>
          <button class="will-creation-btn" @click="willcreation()" v-else>PROCEED TO WILL CREATION</button>
         
        </v-card>
      </div>
    </section>
  </div>
</template>

<script>
export default {
 data: () => ({}),
  methods: {
    willcreation() {
      this.$router.push({ path: '/memberwill/'+this.$route.params.type }).catch(() => {});
    },
    backButton() {
      this.$router.push({ name: 'ValueAddedServices' }).catch(() => {});
    },
  },
}
</script>

<style>
.center-box{
 text-align: center;
}
.thank-box{
 margin-top: 10px;
font: normal normal bold 24px/26px Lato;
letter-spacing: 0px;
color: #272727;
opacity: 1;
}
.checked{
margin-top:25px;
margin-left:430px;
}
.will-payment-p1{
padding:0px;
margin-bottom:0px;
 text-align: center;
font: normal normal medium 13px/19px Lato;
letter-spacing: 0.39px;
color: #7D7D7D;
opacity: 1;
}
.will-payment-p2{
 text-align: center;
font: normal normal medium 13px/19px Lato;
letter-spacing: 0.39px;
color: #7D7D7D;
opacity: 1;
}
.will-creation-btn{
  padding:10px 60px 10px 60px;
  background: #051d42;
  border: 1px solid transparent;
  color: #fff;
  transition: 0.3s all ease-in-out;
  margin-top:40px;
  border-radius: 6px;
}

</style>